export default "__VITE_ASSET__B8GDD9cF__"